<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="11">
        <v-card class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="70" color="grey ">
                  mdi-account-circle
                </v-icon>

                <span class="ml-3 welcomeText"
                  >Hola, {{ user != null ? user.userName : "Sin nombre" }}</span
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-5">
        <span class="sText">Estadísticas</span>
      </v-col>
      <v-col cols="12" lg="5" class="mt-5">
        <v-card color="blue" class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="50" color="white">
                  mdi-trending-up
                </v-icon>

                <span class="ml-3 white--text">Clientes Registrados</span>

                <p class="number">+{{ getTotalUser }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" class="mt-5">
        <v-card color="blue" class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="50" color="white">
                  favorite
                </v-icon>

                <span class="ml-3 white--text"
                  >Reportes Resueltos por el equipo</span
                >
                <p class="number">+{{ getTotalClaimRequests }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <span class="sText">Reportes</span>
        <requests-claim></requests-claim>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { auth } from "../../firebase.config.js";
import { mapState, mapGetters, mapActions } from "vuex";
import requestsClaim from "../../views/admin/RequestsClaim";
export default {
  data() {
    return {
      usersData: [],
      ClaimData: [],
      userData: {},
    };
  },
  components: {
    requestsClaim,
  },
  created() {
    auth.onAuthStateChanged((user) => {
      this.isLogged = !!user;
    });
  },

  mounted() {
    this.loadInf();
  },
  computed: {
    ...mapGetters(["claimRequests", "users", "loadAdmin", "usersAdmin"]),
    getTotalUser() {
      this.usersData = this.users;
      return this.usersData.length == 0 ? "0" : this.usersData.length;
    },
    getTotalClaimRequests() {
      this.ClaimData = this.claimRequests.filter((c) =>
        c.status == undefined ? "" : c.status.toLowerCase() == "resuelto"
      );

      return this.ClaimData.length;
    },
    user() {
      if (this.usersAdmin == null) {
        return null;
      }
      this.usersAdmin.forEach((element) => {
        if (
          element.email.toLowerCase() == auth.currentUser.email.toLowerCase()
        ) {
          this.userData = element;
        }
      });

      return this.userData;
    },
  },
  methods: {
    ...mapActions(["loadUsers", "loadRequests"]),
    async loadInf() {
      await this.loadUsers();
      await this.loadRequests();
    },
  },
};
</script>
<style scoped>
.welcomeText {
  color: rgb(0, 0, 0);
  font-size: 2em;
}
.number {
  margin-left: 15%;
  color: rgb(255, 255, 255);
  font-weight: bold;
  font-size: 3em;
}
.emotionalText {
  color: #ffffff;
  font-size: 2em;
}
.sText {
  color: #000000;
  font-size: 2em;
}
</style>
